import React from 'react'

const Footer = () => {
  return (
    <div>

        <footer class="bg-dark text-white position-relative overflow-hidden pb-0 pt-4 " data-bs-theme="dark"  style={{ backgroundColor: "rgb(5 61 70) !important" }}>

   
 
   
  <div class="position-absolute top-0 end-0 mt-n3 me-n4 d-none d-lg-block">
    <img src="assets/images/elements/decoration-pattern-2.svg" style={{opacity:0.05}} alt="" />
  </div>

  <div class="container position-relative mt-5">
    <div class="row text-center text-md-start">

       
      <div class="col-12 col-md-6 col-lg-3 mb-4">
        	<a class="me-0" href="index">
					<img class="light-mode-item h-40px footer-bg-img" src="img/elegant-advisors-logo.png" alt="logo" />
					<img class="dark-mode-item h-40px footer-bg-img" src="img/elegant-advisors-logo.png" alt="logo" />
				</a>
        <p class="mt-3">Our firm specializes in delivering reliable and tailored financial solutions to businesses of all sizes, helping them maintain Accounting, compliance, optimize tax planning, and improve overall financial efficiency.</p>
      </div>

      <div class="col-12 col-md-6 col-lg-3 mb-4"> 
        <h6 class="mb-3">Quick Links</h6>
        <ul class="nav flex-column">
           
          
          <li><a class="dropdown-item" href="/">Home</a></li>
          <li><a class="dropdown-item" href="about-us">About Us</a></li> 
          <li><a class="dropdown-item" href="constructions-and-real-estate">Clientele</a></li>          
          <li><a class="dropdown-item" href="careers">Careers</a></li>          
          <li><a class="dropdown-item" href="contact-us">Contact us</a></li>
        </ul>
      </div>
       
      <div class="col-12 col-md-6 col-lg-3 mb-4">
        <h6 class="mb-3">Accounting</h6>
        <ul class="nav flex-column">
          <li><a class="dropdown-item" href="accounting-outsourcing">Accounting Outsourcing</a></li>
          <li><a class="dropdown-item" href="accounts-receivable-outsourcing">Accounts Receivable Outsourcing</a></li>
          <li><a class="dropdown-item" href="accounts-payable-outsourcing">Accounts Payable Outsourcing</a></li>
          <li><a class="dropdown-item" href="bookkeeping-outsourcing">Bookkeeping Outsourcing</a></li>
          <li><a class="dropdown-item" href="migrating-accounting-system">Migrating Accounting System</a></li>
        </ul>
      </div>

       
      <div class="col-12 col-md-6 col-lg-3 mb-4">
        <h6 class="mb-3">Auditing</h6>
        <ul class="nav flex-column">
          <li><a class="dropdown-item" href="internal-and-external-auditing">Internal & External Auditing</a></li>
          <li><a class="dropdown-item" href="inventory-audit">Inventory Audit</a></li>
          <li><a class="dropdown-item" href="bank-reconciliation">Bank Reconciliation</a></li>
          <li><a class="dropdown-item" href="construction-stores-stock-audit">Construction stores stock audit</a></li>
          <li><a class="dropdown-item" href="retail-stores-stock-audit">Retail stores stock audit</a></li>
          <li><a class="dropdown-item" href="rrial-balance">Trial Balance</a></li>
          <li><a class="dropdown-item" href="intercompany-audit">Intercompany Audit</a></li>
        </ul>
      </div>
       
      

       
      <div class="col-12 col-md-6 col-lg-3 mb-4">
        <h6 class="mb-3">Follow on</h6>
        <ul className="list-inline flex-wrap mb-0">
                  <li className="list-inline-item">
                    <a
                      href="https://www.facebook.com/profile.php?id=61579123201569"
                      className="btn btn-icon btn-light text-facebook rounded-circle"
                    >
                      <i className="bi bi-facebook"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.instagram.com/eleconsultings/"
                      className="btn btn-icon btn-light text-instagram rounded-circle"
                    >
                      <i className="bi bi-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.linkedin.com/in/elegant-consultings-471032379/"
                      className="btn btn-icon btn-light text-linkedin rounded-circle"
                    >
                      <i className="bi bi-linkedin"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://x.com/eleconsultings/"
                      className="btn btn-icon btn-light text-twitter rounded-circle"
                    >
                      <i className="bi bi-twitter"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.youtube.com/@eleconsultings"
                      className="btn btn-icon btn-light text-youtube rounded-circle"
                    >
                      <i className="bi bi-youtube"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.threads.com/@eleconsultings"
                      className="btn btn-icon btn-light text-youtube rounded-circle"
                    >
                      <i className="bi bi-threads"></i>
                    </a>
                  </li>
                </ul>
      </div>

    </div>

   
    <hr class="mt-4 mb-0 border-light" />

    
    <div class="d-flex flex-column flex-md-row justify-content-between align-items-center text-center py-3">
      <div class="text-white-50 small text-center">
        All copyright reserved by © 2025 Elegant Consultings. Built by <a href="https://elegantconsultings.com" class="text-primary text-decoration-none">Elegant Consultings</a>.
      </div>
    </div>
  </div>
</footer>
      
    </div>
  )
}

export default Footer
